import styled from 'styled-components'
import { DividerProps } from './Divider.props'

const Divider = styled.div<DividerProps>`
  height: ${({ size }) => (size ? `${size}px` : '1px')};
  background-color: ${({ color, theme }) => color || theme.colors.primary};
  margin: ${({ margin }) => (margin ? margin : '')};
`

export default Divider
